export default {
    state: {
        assureur_mod: 'getAssureur',
        assureur:{}
    },
    mutations: {
        setAssureur(state, paylaod) {
            state.assureur = paylaod.assureur
        },
        setAssureurMode(state, paylaod) {
            state.assureur_mod = paylaod.assureur_mod
        }
    },
    actions: {},
    getters: {
        getAssureur(state) {
            return state.assureur
        },
        getAssureurMode(state) {
            return state.assureur_mod
        },
    },
}
